// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessage-modulechatroomMessage__uZUyV";
var _2 = "ChatroomMessage-modulechatroomMessageOwn__Jma_d";
var _3 = "ChatroomMessage-modulecolumn__eOvb9";
var _4 = "ChatroomMessage-modulecolumnOwn__TaAwY";
export { _1 as "chatroomMessage", _2 as "chatroomMessageOwn", _3 as "column", _4 as "columnOwn" }
